import type { IErrorResponse } from '../interfaces/error-response.interface'

const isObject = (obj: any) => Object.prototype.toString.call(obj) === '[object Object]'
const MCE_ERROR = 'MCE:ERROR'

export const getErrorInLocalStorage = () => {
  const error: IErrorResponse = {
    status: 0,
    message: '',
    code: '',
    data: null
  }
  return localStorage.getItem(MCE_ERROR)
    ? JSON.parse(localStorage.getItem(MCE_ERROR) as string)
    : error
}

export const setErrorInLocalStorage = (_error: IErrorResponse) => {
  const errorInLS: IErrorResponse = getErrorInLocalStorage()

  if (isObject(errorInLS)) {
    errorInLS.status = _error.status
    errorInLS.code = _error.code
    errorInLS.data = _error.data
    localStorage.setItem(MCE_ERROR, JSON.stringify(errorInLS))
  }
  errorInLS.message = typeof _error.message === 'string' ? _error.message : ''
  localStorage.setItem(MCE_ERROR, JSON.stringify(errorInLS))
}

export const ERROR_METHODS = {
  TIMEOUT: {
    ORDERS: 'Timeout orders',
    SEND_PIN: 'Timeout sendPin',
    PACKAGES: 'Timeout packages',
    PURCHASE: 'Timeout purchase',
    GET_PROFILE: 'Timeout getProfile'
  },
  BIN: 'BIN Error',
  ORDERS: 'orders',
  PURCHASE: 'purchase',
  RECURRENT: 'recurrent',
  GET_PROFILE: 'getProfile',
  CONFIRM_PIN: 'confirmPin',
  USA_BIN: 'isUsaBin Error',
  GET_TOKEN: 'send number get token',
  CONFIRMATION_LINK: 'send confirmation link',
  SHORT_LINK: 'No offer short link',
  EMPTY_PACKAGE: 'empty package'
}
